import CurrencyFlag from "@common/controls/Flag/component";
import "./style.less";

export default CurrencyFlag;

export { CurrencyFlag, CurrencyFlagWithLabel, type CurrencyFlagWithLabelProps } from "@common/controls/Flag/component";
